export const POST_LOADING = 'POST_LOADING';
export const POST_ERROR = 'POST_ERROR';
export const POST_RESET = 'POST_RESET';
export const UPDATE_POST = 'UPDATE_POST';
export const ALL_POSTS = 'ALL_POSTS';
export const MY_POSTS = 'MY_POSTS';
export const POST_SUCCESS = 'POST_SUCCESS';
